import * as angularRouter from '@angular/router';

// global glue variable for externals
if (window['ng'] == null) window['ng'] = <any>{};

window['ng'].router = angularRouter;

export { angularRouter };